var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('Title',{attrs:{"title":"按工作年限分析","className":"ny-title-small"}}),_c('div',{staticClass:"layout-view withoutTitle pb0"},[_c('EchartsLayout',{attrs:{"option":_vm.option}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }